import 'i18next';
import '../CareDetails';
import { SpecialistCareDetail } from '../../../../../util/care_details/SpecialistCareDetail';
import { CovidInformationCareDetailDescriptor } from '../../../../../util/care_details/CovidInformationCareDetail';
export var getSpecialistCustomizations = function (t) {
    var _a;
    var baseCta = t('baycare.specialistCta', 'Schedule Appointment');
    var imagingCta = t('baycare.imagingTestCta', 'Schedule an appointment here');
    var covidVaccineTitle = t('covidCards.infoCard.vaccine', 'COVID-19 Vaccine Information');
    var covidTestingTitle = t('covidCards.infoCard.testing', 'COVID-19 Testing Information');
    var covidCta = t('covidCards.infoCard.cta', 'See more information');
    return _a = {},
        _a[SpecialistCareDetail.IMAGING_TEST] = {
            buttons: [
                {
                    cta: imagingCta,
                    url: 'https://baycare.opendr.com/?_gl=1*17a1981*_ga*MTk4NjI4MjUzMS4xNjc4MTIyODMw*_ga_HN5DD6D0PP*MTY3ODEyMjgzMC4xLjEuMTY3ODEyMjgzNi41NC4wLjA.&_ga=2.217618516.355879324.1678122836-1986282531.1678122830',
                },
            ],
        },
        _a[SpecialistCareDetail.OBGYN] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=obgyn&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.PULMONOLOGIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=pulmonologist&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.OPHTHALMOLOGIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#sort=relevancy&f:@specialties=[Ophthalmology]',
                },
            ],
        },
        _a[SpecialistCareDetail.GASTROENTEROLOGY] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/services/gastroenterology',
                },
            ],
        },
        _a[SpecialistCareDetail.DERMATOLOGY] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/services/dermatology',
                },
            ],
        },
        _a[SpecialistCareDetail.KNEE_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=orthopedics%20knee&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.UROLOGIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/services/urology',
                },
            ],
        },
        _a[SpecialistCareDetail.ENT] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/services/ear-nose-and-throat',
                },
            ],
        },
        _a[SpecialistCareDetail.NEUROLOGY] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=neurologist',
                },
            ],
        },
        _a[SpecialistCareDetail.CARDIOLOGY] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=cardiology',
                },
            ],
        },
        _a[SpecialistCareDetail.SHOULDER_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=orthopedic%20shoulder&sort=relevancy&f:@specialties=[Orthopedics]',
                },
            ],
        },
        _a[SpecialistCareDetail.HAND_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=hand%20and%20wrist%20surgery&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.FOOT_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=foot%20and%20ankle%20orthopedic&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.SPINE_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/services/orthopedics/spine-care',
                },
            ],
        },
        _a[SpecialistCareDetail.FOREARM_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=upper%20extremity&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.HIP_SPECIALIST] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=orthopedic%20hip&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=orthopedics&sort=relevancy',
                },
            ],
        },
        _a[SpecialistCareDetail.PODIATRY] = {
            buttons: [
                {
                    cta: baseCta,
                    url: 'https://baycare.org/doctors#q=podiatry&sort=relevancy',
                },
            ],
        },
        _a[CovidInformationCareDetailDescriptor.COVID_19_VACCINE_INFORMATION] = {
            title: covidVaccineTitle,
            buttons: [
                {
                    cta: covidCta,
                    url: 'https://baycare.org/specialties-and-treatments/coronavirus/vaccines',
                },
            ],
        },
        _a[CovidInformationCareDetailDescriptor.COVID_19_TESTING_INFORMATION] = {
            title: covidTestingTitle,
            buttons: [
                {
                    cta: covidCta,
                    url: 'https://baycare.org/specialties-and-treatments/coronavirus/vaccines',
                },
            ],
        },
        _a;
};
